import { Modal, ModalProps, Table, TableColumnsType } from 'antd';
import dayjs from 'lib/dayjs';
import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import { StatusHistory } from 'services/api/refund';

export interface StatusHistoryModalProps extends ModalProps {
  data: StatusHistory[];
}

export const useStatusLabel = () => {
  const { t } = useTranslate();

  return useMemo<Record<Conversation.Trade.LazadaDisplayStatus, string>>(() => {
    return {
      REQUEST_INITIATE: t('ViewRefund.买家发起退货'),
      BUYER_RETURN_ITEM: t('ViewRefund.买家退回商品'),
      SELLER_AGREE_RETURN: t('ViewRefund.等待买家退货'),
      CS_APPROVING: t('ViewRefund.官方审核中'),
      SELLER_AGREE_REFUND: t('ViewRefund.等待退款'),
      REFUND_PENDING: t('ViewRefund.等待退款'),
      REFUND_SUCCESS: t('ViewRefund.退款成功'),
      REQUEST_CANCEL: t('ViewRefund.买家已取消申请'),
      SELLER_REJECT_RETURN: t('ViewRefund.已拒绝买家退货'),
      SELLER_REJECT_REFUND: t('ViewRefund.已拒绝退款'),
      REFUND_REJECT: t('ViewRefund.已拒绝退款'),
      REQUEST_REJECT: t('ViewRefund.已拒绝买家申请'),
    };
  }, [t]);
};

function StatusHistoryModal(props: StatusHistoryModalProps) {
  const { data, ...otherProps } = props;

  const { t } = useTranslate();

  const statusLabel = useStatusLabel();

  const columns: TableColumnsType<StatusHistory> = [
    {
      key: 'returnStatus',
      dataIndex: 'returnStatus',
      title: t('aide.状态'),
      render: (status: StatusHistory['returnStatus']) => statusLabel[status] || '-',
    },
    {
      key: 'updateTimeMs',
      dataIndex: 'updateTimeMs',
      title: t('ViewRefund.更改日期'),
      render: (time: StatusHistory['updateTimeMs']) =>
        dayjs(Number(time)).format('YYYY-MM-DD HH:mm:ss'),
    },
  ];

  return (
    <Modal title={t('ViewRefund.状态历史')} width={582} footer={null} {...otherProps}>
      <Table dataSource={data} columns={columns} pagination={false} />
    </Modal>
  );
}

export default StatusHistoryModal;
